import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/var/www/html/src/layouts/auth/Auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/var/www/html/src/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/var/www/html/src/layouts/empty.vue").then(m => m.default || m)),
  panel: defineAsyncComponent(() => import("/var/www/html/src/layouts/panel.vue").then(m => m.default || m)),
  tablet: defineAsyncComponent(() => import("/var/www/html/src/layouts/tablet/Tablet.vue").then(m => m.default || m))
}